import { createI18n } from 'vue-i18n'

let messages = {};
if (window.hasOwnProperty('kgr')) {
    messages = kgr.i18n._messages;
}

const numberFormats = {
    'de': {
        currency: {
            style: 'currency',
            currency: 'EUR',
        }
    },
};

const i18nInstance = createI18n({
    locale: 'kgr',
    fallbackLocale: 'kgr',
    messages: {
        kgr: messages,
    },
    numberFormats: numberFormats,
});

export const plugin = {
    install(app) {
        app.use(i18nInstance);
        app.provide('i18n', i18nInstance.global);
    },
};

export const i18n = i18nInstance.global
